import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { File as FileModel } from 'src/app/classes/models/file';

import { AMBest } from '../classes/models/am-best';
import { AuthService } from './auth.service';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class AdminService {
  constructor(
    private http: HttpClient,
    private AuthService: AuthService,
    private ToastService: ToastService
  ) {}

  public getAmBest(query = {}) {
    return this.http.get<AMBest | null>(`/api/v2/admin/amBests/one`, {
      params: query
    });
  }

  public sendCOIToBeScanned(File: FileModel, query = {}) {
    return this.http.post<any>(
      `/api/v2/admin/insurance/insuranceCertificate/sendCOIToBeScanned`,
      File,
      { params: query }
    );
  }

  // Untested. Still need to test.
  public getAllClientFiles(
    CompanyId: number,
    limit: number,
    offset: number,
    filePart: number,
    filesToRetrieveObj = {},
    query = {}
  ): Observable<any> {
    // POST request treated like a GET request. Make sure to test this.
    return this.http.post(
      `/api/v2/admin/files/getAllClientFiles/${limit}/${offset}/${filePart}/${CompanyId}`,
      filesToRetrieveObj,
      { params: query }
    );
  }
  public getAllClientVendorAgreementsAndW9s(
    CompanyId: number,
    limit: number,
    offset: number
  ): Observable<any> {
    // POST request treated like a GET request. Make sure to test this.
    return this.http.post(
      `/api/v2/admin/files/getAllClientVendorAgreementsAndW9s/${CompanyId}/${limit}/${offset}`,
      {}
    );
  }
}
